import _last from 'lodash/last';

export default (uri = ''): { roomId: string; searchString?: string } => {
    if (!uri) {
        return {
            roomId: '',
            searchString: '',
        };
    }

    let url;
    if (NODE) {
        const { URL } = require('url');
        url = new URL(uri);
    } else {
        url = new URL(uri);
    }
    return {
        roomId: _last(url.pathname.split('/')) || '',
        searchString: url.search,
    };
};
